import React from 'react';

const UserProfile = () => (
  <div>UserProfile</div>
);

export default UserProfile;
